(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kt-highlights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.kthReady) return;
      root.dataset.kthReady = '1';
      var track = root.querySelector('[data-kth-track]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-kth-item]'));
      var n = items.length;
      if (!n) return;
      var tabs = items.map(function (it) { return it.querySelector('[data-kth-tab]'); });
      var media = items.map(function (it) { return it.querySelector('[data-kth-media]'); });
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kth-dot]'));
      var cur = 0;
      items.forEach(function (it, i) { if (it.classList.contains('is-active')) cur = i; });

      function isCards() { return track && getComputedStyle(track).display === 'flex'; }
      function playVideo(v) { if (!v) return; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }

      function setActive(next, opts) {
        opts = opts || {};
        next = ((next % n) + n) % n;
        items.forEach(function (it, i) {
          var on = i === next;
          it.classList.toggle('is-active', on);
          var t = tabs[i];
          if (t) {
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            t.classList.toggle('button--solid', on);
            t.classList.toggle('button--outline', !on);
          }
          var p = it.querySelector('[role="tabpanel"]');
          if (p) { if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); }
          var m = media[i];
          if (m) {
            m.classList.toggle('is-active', on);
            m.setAttribute('aria-hidden', on ? 'false' : 'true');
            var v = m.querySelector('[data-kth-video]');
            if (v) { if (on && !v.dataset.userPaused) playVideo(v); else if (!on) v.pause(); }
          }
        });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === next); });
        if (isCards()) {
          items.forEach(function (it, i) {
            if (i !== next && it.classList.contains('is-open')) {
              it.classList.remove('is-open');
              var b = it.querySelector('[data-kth-more]'); if (b) { b.setAttribute('aria-expanded', 'false'); var tx = b.querySelector('[data-kth-more-text]'); if (tx) tx.textContent = 'もっと見る'; }
            }
          });
        }
        cur = next;
        if (opts.scroll && isCards()) {
          items[next].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
        if (opts.focus && tabs[next]) tabs[next].focus();
      }

      tabs.forEach(function (t, i) {
        if (!t) return;
        t.addEventListener('click', function () { setActive(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key;
          if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); setActive(cur + 1, { focus: true }); }
          else if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); setActive(cur - 1, { focus: true }); }
          else if (k === 'Home') { e.preventDefault(); setActive(0, { focus: true }); }
          else if (k === 'End') { e.preventDefault(); setActive(n - 1, { focus: true }); }
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-kth-dir]'), function (b) {
        b.addEventListener('click', function () { setActive(cur + parseInt(b.getAttribute('data-kth-dir'), 10)); });
      });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { setActive(i, { scroll: true }); }); });

      // モバイルの「＋ もっと見る」（本文の開閉）
      items.forEach(function (it) {
        var b = it.querySelector('[data-kth-more]');
        if (!b) return;
        var txt = b.querySelector('[data-kth-more-text]');
        b.addEventListener('click', function () {
          var open = !it.classList.contains('is-open');
          it.classList.toggle('is-open', open);
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (txt) txt.textContent = open ? '閉じる' : 'もっと見る';
        });
      });

      // 動画の再生 / 一時停止ボタン
      Array.prototype.forEach.call(root.querySelectorAll('[data-kth-vbtn]'), function (b) {
        var v = b.parentElement.querySelector('[data-kth-video]');
        if (!v) return;
        function sync() {
          var paused = v.paused;
          b.classList.toggle('is-paused', paused);
          b.setAttribute('aria-pressed', paused ? 'true' : 'false');
          b.setAttribute('aria-label', paused ? '動画を再生' : '動画を一時停止');
        }
        b.addEventListener('click', function () {
          if (v.paused) { delete v.dataset.userPaused; playVideo(v); } else { v.dataset.userPaused = '1'; v.pause(); }
        });
        v.addEventListener('play', sync); v.addEventListener('pause', sync); sync();
      });

      // モバイル（横スワイプ）: 見えているカードを現在位置にする
      if ('IntersectionObserver' in window && track) {
        var io = new IntersectionObserver(function (entries) {
          if (!isCards()) return;
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) {
              var i = parseInt(en.target.getAttribute('data-kth-item'), 10);
              if (i !== cur) setActive(i);
            }
          });
        }, { root: track, threshold: [0.6] });
        items.forEach(function (it) { io.observe(it); });

        // 画面外では動画を止める（省電力）
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = media[cur] && media[cur].querySelector('[data-kth-video]');
            if (!v) return;
            if (en.isIntersecting) { if (!v.dataset.userPaused) playVideo(v); } else { v.pause(); }
          });
        }, { threshold: 0.15 });
        vio.observe(root);
      }
    }

    function initAll() { Array.prototype.forEach.call(document.querySelectorAll('[data-kth]'), init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target && e.target.querySelector ? e.target.querySelector('[data-kth]') : null;
      if (r) { delete r.dataset.kthReady; init(r); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
